import { IOrganization } from '@/pages/Organizations/organizations.types.ts'
import useOrganization from '../../hooks/useOrganization'
import { NavLink } from 'react-router-dom'
import urls from '@/navigation/urls.ts'

interface IProps {
  organizationId: IOrganization['id']
}

const OrganizationLink = (props: IProps) => {
  const organization = useOrganization(props.organizationId)

  if (!organization.organization) {
    return null
  }

  return (
    <NavLink
      to={urls.organizations + '?organizationId=' + organization.organization.id}
      className="text-nm text-link"
      style={{ textDecoration: 'none' }}
    >
      {organization.organization?.name}
    </NavLink>
  )
}

export default OrganizationLink
